/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

export default function getGlobals(colors) {
  const { info, dark, background } = colors;

  return {
    html: {
      scrollBehavior: "smooth",
    },
    "*, *::before, *::after": {
      margin: 0,
      padding: 0,
    },
    body: {
      backgroundColor: background.default,
    },
    "a, a:link, a:visited": {
      textDecoration: "none !important",
    },
    "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
      color: `${dark.main} !important`,
      transition: "color 150ms ease-in !important",
    },
    "a.link:hover, .link:hover, a.link:focus, .link:focus": {
      color: `${info.main} !important`,
    },
  };
}
